import { API_URL } from '../configs/config';

export function formatUrl(path: string): string {
  return new URL(path, API_URL).href;
}
